import React, { useState, useRef, useEffect, useCallback, useMemo, use } from 'react';
import axios from '../plugins/axios'
import moment from 'moment'
import { useRecoilState } from 'recoil';
import { isFromSearchState, selectBedInfoState, trendZoomState } from '../plugins/recoil';
import { useTranslation } from 'react-i18next';

import ReviewAreaDateModal from './ReviewAreaDateModal';
import TrendDetailView from './TrendDetailView';
import Timeline from './NewTimeline'
import HalfMenus from './halfMenus';

import {ReactComponent as IconCalendar} from '../assets/icons/ic-calendar.svg'
import {ReactComponent as IconCalendarLeft} from '../assets/icons/ic-calendar-left.svg'
import {ReactComponent as IconCalendarRight} from '../assets/icons/ic-calendar-right.svg'
import {ReactComponent as IconArrowUp} from '../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../assets/icons/ic-check_blue.svg';
import {ReactComponent as IconSearch} from '../assets/icons/ic-search.svg';
import {ReactComponent as IconPerson} from '../assets/icons/ic-person.svg';
import {ReactComponent as IconErrorYellow} from '../assets/icons/ic-error-yellow.svg';
import LoadingIcon from '../assets/icons/loading.gif';

import './AlarmReview.scss'

import { checkEmptyValue } from '../plugins/common';

const AlarmListItem = React.memo(({ 
    item, 
    idx, 
    selectedAlarmNum, 
    currentActivePatient,
    prevActivePatient,
    isPatientChanged,
    onAlarmClick,
    isFromSearch,
    t 
}) => {
    const displayPatientInfo = currentActivePatient ? {
        patientId: currentActivePatient.patientId || t('alarmReview.notAdmitted'),
        patientName: currentActivePatient.patientName || t('alarmReview.notAdmitted'),
        devicePatientId: currentActivePatient.devicePatientId || '',
        status: currentActivePatient.status
    } : {
        patientId: t('alarmReview.unknown'),
        patientName: t('alarmReview.unknown'),
        devicePatientId: t('alarmReview.unknown'),
        status: 'UNKNOWN'
    };

    return (
        <React.Fragment>
            {isPatientChanged && (
                <>
                    {idx > 0 && (
                        <div className="h-[1px] bg-[#000000] w-full my-[2px]" />
                    )}
                    <div className="sticky top-0 bg-[#1F1F1F] z-10 flex items-center h-[48px] text-white" style={{ fontWeight: 600, fontSize: 18 }}>
                        <IconPerson className="mr-2 min-w-[28px]" />
                        <div className="min-w-0 flex-1">
                            {
                                (!isFromSearch && displayPatientInfo.status === 'UNASSIGNED') ?
                                <span className="block truncate">{t('alarmReview.notAdmitted')}</span> :
                                <div className="truncate">
                                    <span>{displayPatientInfo.patientName}</span>
                                    <span className="text-[#DEDEDE]">{displayPatientInfo.devicePatientId ? `, ${displayPatientInfo.devicePatientId}` : ''}</span>
                                </div>
                            } 
                        </div>
                    </div>
                </>
            )}
            <div 
                onClick={() => onAlarmClick(idx, item)} 
                className={`cursor-pointer flex items-center h-[34px] w-full px-1 ${selectedAlarmNum === item.alarmNum ? 'selected-alarm' : ''}`} 
                style={{ padding: 8, fontWeight: 300, fontSize: 16, lineHeight: '17.6px' }}
            >
                <div className="" style={{ maxWidth: 165, minWidth: 165 }}>
                    { item.startTime }
                </div>
                <div className="truncate" style={{ fontFamily: 'Roboto', maxWidth: 210 ,fontWeight: 400, color: item.eventPriority == 2 ? '#FF002E' : (item.eventPriority == 1 || item.eventPriority == 0 ) ? '#FFF500' : 'white' }}>
                    {checkEmptyValue(item.eventMessage)}
                </div>
            </div>
        </React.Fragment>
    );
}, (prevProps, nextProps) => {
    // 커스텀 비교 함수 - 필요한 props만 비교
    return (
        prevProps.item.alarmNum === nextProps.item.alarmNum &&
        prevProps.selectedAlarmNum === nextProps.selectedAlarmNum &&
        prevProps.isPatientChanged === nextProps.isPatientChanged &&
        prevProps.currentActivePatient?.patientId === nextProps.currentActivePatient?.patientId
    );
});

const AlarmReview = ({ isAlarmFull, onClose, onTrend, onSetting, onMeasurements, handleFullScreen }) => {
    const { t } = useTranslation()
    const [showTimeValue, setShowTimeValue] = useState(17)
    const [selectedAlarmIdx, setSelectedAlarmIdx] = useState(null)
    const [selectedAlarmInfo, setSelectedAlarmInfo] = useState({});
    const [isDateModalShow, setIsDateModalShow] = useState(false)
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)
    const [isFromSearch, ] = useRecoilState(isFromSearchState)
    const [isGraphicTrendVisible, setGraphicTrendVisible] = useState(false);
    const [trendWaveData, setTrendWaveData] = useState()
    const [trendReviewData, setTrendReviewData] = useState({})
    const [endDateTrigger, setEndDateTrigger] = useState(false)
    const [startDateTrigger, setStartDateTrigger] = useState(false)
    const [calendarAlarms, setCalendarAlarms] = useState([])
    const [listOpen, setListOpen] = useState(true)
    const [waveStartTime, setWaveStartTime] = useState(null)
    const [waveEndTime, setWaveEndTime] = useState(null)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [alarmType, setAlarmType] = useState({ label: t('alarmReview.allAlarms'), value: 'all' })
    const [alarmTitle, setAlarmTitle] = useState('')
    const [patientHistories, setPatientHistories] = useState([])
    const [latestPatientHistory, setLatestPatientHistory] = useState(null)
    const [activePatient, setActivePatient] = useState({})
    const [showNotCurrentPatient, setShowNotCurrentPatient] = useState(false)
    const [alarmListVersion, setAlarmListVersion] = useState(0);

    const dropdownRef = useRef(null)
    const wrapperRef = useRef(null)
    const dateModalRef = useRef(null)
    const dateModalOpenRef = useRef(null)
    const alarmListRef = useRef(null)
    const alarmListItemRefs = useRef([])
    const alarmLoading = useRef(true)
    const startDate = useRef(null)
    const endDate = useRef(null)
    const alarmOldList = useRef([])
    const searchModalOpenRef = useRef(null)
    const searchModalRef = useRef(null)
    const alarmReviewList = useRef([])

    const alarmTypeOptions = [
        { label: t('alarmReview.allAlarms'), value: 'all' },
        { label: t('alarmReview.redAlarms'), value: 2 },
        { label: t('alarmReview.yellowAlarms'), value: 1 },
        { label: t('alarmReview.whiteAlarms'), value: 0 },
    ]

    const getActivePatientAtTime = useCallback((timestamp) => {
        if (!patientHistories || patientHistories.length === 0) {
            const defaultPatient = {
                ...selectBedInfo,
            };
            return defaultPatient;
        }
        
        const targetTime = moment(timestamp);
        
        // 해당 시간 이전 또는 같은 시간의 모든 히스토리를 시간순으로 정렬 (최신순)
        const relevantHistories = patientHistories
            .filter(history => moment(history.createdAt).isBefore(targetTime) || moment(history.createdAt).isSame(targetTime))
            .sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)));
        
        // 관련 히스토리가 없으면 Not Admitted
        if (relevantHistories.length === 0) {
            // patientHistories의 가장 이른 히스토리 확인
            const earliestHistory = patientHistories
                .sort((a, b) => moment(a.createdAt).diff(moment(b.createdAt)))[0];
            
            // 가장 이른 히스토리가 UNASSIGNED이면, 그 이전에는 해당 환자가 ADMITTED 상태였음
            if (earliestHistory && earliestHistory.action === 'UNASSIGNED') {
                return {
                    patientId: earliestHistory.patientId,
                    patientName: earliestHistory.patientName,
                    devicePatientId: earliestHistory.devicePatientId,
                    status: 'ADMITTED'
                };
            }
            return {
                patientId: null,
                patientName: t('alarmReview.notAdmitted'),
                devicePatientId: '',
                status: 'UNASSIGNED'
            };
        }
        
        // 가장 최근의 액션을 확인
        const latestHistory = relevantHistories[0];
        let currentPatient;
        if (latestHistory.action === 'ADMITTED') {
            currentPatient = {
                patientId: latestHistory.patientId,
                patientName: latestHistory.patientName,
                devicePatientId: latestHistory.devicePatientId,
                status: 'ADMITTED'
            };
        } else if (latestHistory.action === 'UNASSIGNED') {
            // UNASSIGNED 상태면 Not Admitted로 표시
            currentPatient = {
                patientId: null,
                patientName: t('alarmReview.notAdmitted'),
                devicePatientId: '',
                status: 'UNASSIGNED'
            };
        } else {
            currentPatient = {
                patientId: null,
                patientName: t('alarmReview.notAdmitted'),
                devicePatientId: '',
                status: 'UNASSIGNED'
            };
        }
        
        return currentPatient;
    }, [patientHistories]);

    const setActivePatientForAlarm = useCallback((timestamp) => {
        const patient = getActivePatientAtTime(timestamp);
        setActivePatient(patient);
    }, [getActivePatientAtTime]);

    const handleClickOutside = event => {
        if (dateModalOpenRef.current && dateModalOpenRef.current.contains(event.target)) return
        if (searchModalOpenRef.current && searchModalOpenRef.current.contains(event.target)) return
        if (dateModalRef.current && !dateModalRef.current.getDom().contains(event.target)) {
            setIsDateModalShow(false)
        }
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false)
        }  
    }

    const handleDateModal = () => {
        setIsDateModalShow(!isDateModalShow)
    }

    const handleSearch = (start, end) => {
        startDate.current = start
        endDate.current = end
        setIsDateModalShow(false)
        setStartDateTrigger(!startDateTrigger)
    }

    const handleChangeAlarmFilter = (type, search, isInit) => {
        if (type.value === 'all' && search.trim() === '') {
            alarmReviewList.current = alarmOldList.current
        } else if (type.value === 'all' && !(search.trim() === '')) {
            alarmReviewList.current = alarmOldList.current.filter(alarm => ((alarm.startTime.includes(search) || alarm.eventMessage.toLowerCase().includes(search.toLowerCase()))));
        } else if (type.value !== 'all' && search.trim() === '') {
            alarmReviewList.current = alarmOldList.current.filter(alarm => (alarm.eventPriority === type.value ));
        } else {
            alarmReviewList.current = alarmOldList.current.filter(alarm => (alarm.eventPriority === type.value && (alarm.startTime.includes(search) || alarm.eventMessage.toLowerCase().includes(search.toLowerCase()))));
        }
        setAlarmListVersion(prev => prev + 1);

        if (isInit && alarmReviewList.current.length > 0) {
            setSelectedAlarmIdx(0); // 리스트의 첫 번째 항목
            handleAlarmClick(0);
        }
    }

    const getAlarmList = async (offset = 0) => {
        if (!endDate.current || !startDate.current) return
        try {
            const res = await axios.get(`/trend/alarm/event?serialNo=${selectBedInfo.serial}&startTime=${moment.utc(startDate.current).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment.utc(endDate.current).format('YYYY-MM-DDTHH:mm:ss')}Z`)            
            if(res.code != '200') throw res
            const alarmData = res.data.events.map((alarm, idx) => {
                return {
                    ...alarm,
                    alarmNum: idx,
                    utcStartTime : alarm.startTime,
                    utcEndTime : alarm.endTime,
                    startTime: moment(alarm.startTime).format('YYYY-MM-DD HH:mm:ss'),
                    endTime: moment(alarm.endTime).format('YYYY-MM-DD HH:mm:ss'),
                }
            })
            alarmOldList.current = alarmData
            alarmReviewList.current = alarmData
            handleChangeAlarmFilter(alarmType, alarmTitle, true) 
            alarmLoading.current = false
            setAlarmListVersion(prev => prev + 1)
        } catch (err) { 
            console.warn(err)
            alarmLoading.current = false
            alarmReviewList.current = []
            setAlarmListVersion(prev => prev + 1)
        }
    }

    const getAlarmListForSearch = async () => {
        if (!endDate.current || !startDate.current) return
        try {
            const getActiveSerialsInPeriod = () => {
                if (!selectBedInfo.deviceHistory || selectBedInfo.deviceHistory.length === 0) {
                    return [selectBedInfo.serial];
                }

                const startTime = moment(startDate.current);
                const endTime = moment(endDate.current);
                const activeSerials = new Set();

                // deviceHistory를 시간순으로 정렬
                const sortedHistory = [...selectBedInfo.deviceHistory].sort((a, b) => 
                    moment(a.createdAt).diff(moment(b.createdAt))
                );

                let currentSerial = null;
                let currentAdmittedTime = null;

                for (const history of sortedHistory) {
                    const historyTime = moment(history.createdAt);

                    if (history.action === 'ADMITTED') {
                        currentSerial = history.serial;
                        currentAdmittedTime = historyTime;
                    } else if (history.action === 'UNASSIGNED' && currentSerial) {
                        // ADMITTED ~ UNASSIGNED 기간이 검색 기간과 겹치는지 확인
                        const admittedTime = currentAdmittedTime;
                        const unassignedTime = historyTime;
                        
                        // 기간이 겹치는 경우 serial 추가
                        if (admittedTime.isBefore(endTime) && unassignedTime.isAfter(startTime)) {
                            activeSerials.add(currentSerial);
                        }
                        
                        currentSerial = null;
                        currentAdmittedTime = null;
                    }
                }

                // 마지막 ADMITTED 상태가 종료되지 않은 경우 (현재 사용 중)
                if (currentSerial && currentAdmittedTime) {
                    // ADMITTED 시간이 검색 종료 시간보다 이전이면 해당 serial 포함
                    if (currentAdmittedTime.isBefore(endTime)) {
                        activeSerials.add(currentSerial);
                    }
                }

                return activeSerials.size > 0 ? Array.from(activeSerials) : [selectBedInfo.serial];
            };

            const activeSerials = getActiveSerialsInPeriod();

            // 각 serial에 대해 API 호출
            const alarmPromises = activeSerials.map(serial => 
                axios.get(`/trend/alarm/event?serialNo=${serial}&startTime=${moment(startDate.current).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(endDate.current).format('YYYY-MM-DDTHH:mm:ss')}Z`)
            );

            const responses = await Promise.all(alarmPromises);
            
            // 모든 응답을 하나로 합치기
            const allAlarmData = [];
            responses.forEach((res, index) => {
                if(res.code == '200') {
                    const serialAlarmData = res.data.events.map((alarm) => {
                        return {
                            ...alarm,
                            startTime: moment(alarm.startTime).format('YYYY-MM-DD HH:mm:ss'),
                            endTime: moment(alarm.endTime).format('YYYY-MM-DD HH:mm:ss'),
                        }
                    });
                    allAlarmData.push(...serialAlarmData);
                }
            });
            // 시간순으로 정렬
            allAlarmData.sort((a, b) => moment(b.startTime).diff(moment(a.startTime)));

            // alarmNum 재할당
            allAlarmData.forEach((alarm, idx) => {
                alarm.alarmNum = idx;
            });

            alarmOldList.current = allAlarmData;
            alarmReviewList.current = allAlarmData;
            handleChangeAlarmFilter(alarmType, alarmTitle, true);
            alarmLoading.current = false;
            setAlarmListVersion(prev => prev + 1);
        } catch (err) { 
            console.warn(err)
            alarmLoading.current = false
            alarmReviewList.current = []
            setAlarmListVersion(prev => prev + 1);
        }
    }

    const getPatientHistory = async () => {
        try {
            const res = await axios.get(`/device/${selectBedInfo.deviceId}/patient/histories?startDate=${moment(startDate.current).utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endDate=${moment(endDate.current).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`)
            if (res.code != '200') throw res
            if (res.data.histories.length === 0) {
                const newHistory = []
                if (res.data.latestHistory) {
                    newHistory.push(res.data.latestHistory)
                }
                setPatientHistories(newHistory)
            } else {
                setPatientHistories(res.data.histories)
            }
        } catch (err) { console.warn(err) }
    }

    const handleWaveTime = (type) => {
        const endOfStartTime = moment(selectedAlarmInfo.startTime).subtract(15, 'seconds')
        const endOfEndTime = moment(selectedAlarmInfo.endTime).add(15, 'seconds')
        
        switch(type) {
            case 'prev':
                const newStartTime = moment(waveStartTime).subtract(3, 'seconds');
                
                if (newStartTime.isBefore(moment(endOfStartTime))) {
                    setWaveStartTime(moment(endOfStartTime));
                    let newWaveEndTime = null
                    if (moment(endOfEndTime).diff(moment(endOfStartTime), 'seconds') > showTimeValue) {
                        newWaveEndTime = moment(endOfStartTime).add(showTimeValue, 'seconds')
                    } else {
                        newWaveEndTime = moment(endOfEndTime)
                    }
                    setWaveEndTime(newWaveEndTime);
                } else {
                    setWaveStartTime(newStartTime);
                    setWaveEndTime((prev) => moment(prev).subtract(3, 'seconds'));
                }
                break;
            case 'prevEnd':
                setWaveStartTime(moment(endOfStartTime))
                let newWaveEndTime = null
                if (moment(endOfEndTime).diff(moment(endOfStartTime), 'seconds') > showTimeValue) {
                    newWaveEndTime = moment(endOfStartTime).add(showTimeValue, 'seconds')
                } else {
                    newWaveEndTime = moment(endOfEndTime)
                }
                setWaveEndTime(newWaveEndTime);
                break;
            case 'next':
                const newEndTime = moment(waveEndTime).add(3, 'seconds')
                if (newEndTime.isAfter(moment(endOfEndTime))) {
                    setWaveEndTime(moment(endOfEndTime));
                    let newWaveStartTime = null
                    if (moment(endOfEndTime).diff(moment(endOfStartTime), 'seconds') > showTimeValue) {
                        newWaveStartTime = moment(endOfEndTime).subtract(showTimeValue, 'seconds')
                    } else {
                        newWaveStartTime = moment(endOfStartTime)
                    }
                    setWaveStartTime(newWaveStartTime);
                } else {
                    setWaveStartTime((prev) => moment(prev).add(3, 'seconds'));
                    setWaveEndTime(newEndTime);
                }
                break;
            case 'nextEnd':
                let newWaveStartTime = null
                if (moment(endOfEndTime).diff(moment(endOfStartTime), 'seconds') > showTimeValue) {
                    newWaveStartTime = moment(endOfEndTime).subtract(showTimeValue, 'seconds')
                } else {
                    newWaveStartTime = moment(endOfStartTime)
                }
                setWaveStartTime(newWaveStartTime)
                setWaveEndTime(moment(endOfEndTime))
                break;
            default:
                break;
        }
    }

    const handleChangeStartDate = (flag) => {
        switch(flag) {
            case 'prev':
                if (isFromSearch) {
                    if (moment(endDate.current).subtract(2, 'days').isAfter(moment(selectBedInfo.startTime))) {
                        endDate.current = new Date(moment(endDate.current).subtract(1, 'days'))
                    } else {
                        endDate.current = new Date(moment(selectBedInfo.startTime).add(1, 'days'))
                    }
                } else {
                    endDate.current = new Date(moment(endDate.current).subtract(1, 'days'))
                }
                setEndDateTrigger(!endDateTrigger)
                break;
            case 'next':
                if (isFromSearch) {
                    if (moment(endDate.current).add(1, 'days').isBefore(moment(selectBedInfo.endTime))) {
                        endDate.current = new Date(moment(endDate.current).add(1, 'days'))
                        setEndDateTrigger(!endDateTrigger)
                    } else {
                        if (moment(endDate.current).format('YYYY-MM-DD HH:mm') !== moment(selectBedInfo.endTime).format('YYYY-MM-DD HH:mm')) {
                            endDate.current = new Date(moment(selectBedInfo.endTime))
                            setEndDateTrigger(!endDateTrigger)
                        }
                    }
                } else {
                    if (moment().isAfter(moment(endDate.current).add(1, 'days'))) {
                        endDate.current = new Date(moment(endDate.current).add(1, 'days'))
                        setEndDateTrigger(!endDateTrigger)
                    }
                }
                break;
            default : 
                console.log('[handleChangeStartDate] flag',flag);
                break;
        }
    }

    //Alarm List에 있는 Alarm을 클릭하면 발생하는 함수
    const handleAlarmClick = (idx) => {
        if (
            !alarmReviewList.current ||
            !Array.isArray(alarmReviewList.current) ||
            !alarmReviewList.current[idx]
        ) {
            return;
        }
        setSelectedAlarmIdx(idx);
        const selectedAlarm = alarmReviewList.current[idx]
        setSelectedAlarmInfo(selectedAlarm)

        const endOfStartTime = moment(selectedAlarm.startTime).subtract(15, 'seconds')
        const endOfEndTime = moment(selectedAlarm.endTime).add(15, 'seconds')

        let newEndTime = null, newStartTime = moment(selectedAlarm.startTime)
        if (moment(selectedAlarm.endTime).diff(moment(selectedAlarm.startTime), 'seconds') > showTimeValue) {
            newEndTime = moment(selectedAlarm.startTime).add(showTimeValue, 'seconds')
        } else {
            if (moment(endOfEndTime).diff(moment(selectedAlarm.startTime), 'seconds') > showTimeValue) {
                newEndTime = moment(selectedAlarm.startTime).add(showTimeValue, 'seconds')
            } else {
                newStartTime = moment(endOfEndTime).subtract(showTimeValue, 'seconds')
                newEndTime = moment(endOfEndTime)
            }
        }
        setWaveStartTime(moment(newStartTime))
        setWaveEndTime(moment(newEndTime))
    };

    const getVitalSignDetail = async () => {
        // try {
        //     const selectedAlarm = alarmReviewList.current[selectedAlarmIdx]
        //     const res = await axios.get(`/trend/${selectBedInfo.piNo}/vital-sign/detail?startTime=${moment(selectedAlarm.time).subtract(30, 'seconds').utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(selectedAlarm.time).utc().format('YYYY-MM-DDTHH:mm:ss')}Z`)
        //     setTrendReviewData(res)
        // } catch (err) { 
        //     // console.warn(err)
        //     setTrendReviewData({})
        // }
    }

    const patientInfoCache = useMemo(() => {
        if (!alarmReviewList.current || alarmReviewList.current.length === 0) return {};
        
        const cache = {};
        alarmReviewList.current.forEach((item) => {
            cache[item.alarmNum] = getActivePatientAtTime(item.startTime);
        });
        return cache;
    }, [alarmListVersion, patientHistories]); // getActivePatientAtTime 제거

    const patientChangeInfo = useMemo(() => {
        if (!alarmReviewList.current || alarmReviewList.current.length === 0) return [];
        
        return alarmReviewList.current.map((item, idx) => {
            const currentActivePatient = patientInfoCache[item.alarmNum];
            const prevActivePatient = idx > 0 ? patientInfoCache[alarmReviewList.current[idx - 1].alarmNum] : null;
            
            const isPatientChanged = idx === 0 || 
                (currentActivePatient?.patientId !== prevActivePatient?.patientId) ||
                (currentActivePatient?.status !== prevActivePatient?.status);
            
            return {
                currentActivePatient,
                prevActivePatient,
                isPatientChanged
            };
        });
    }, [alarmListVersion, patientInfoCache]);
    
    useEffect(() => {
        if (isDateModalShow) {
            dateModalRef.current?.init(endDate.current)
        }
    }, [isDateModalShow])

    useEffect(() => {
        if (startDate.current) {
            if (isFromSearch) {
                getAlarmListForSearch()
            } else {
                getAlarmList()
                getPatientHistory()
            }
            setSelectedAlarmIdx(null)
            setSelectedAlarmInfo({})
        }
    }, [startDateTrigger])

    useEffect(() => {
        // 초기화
        if (endDate.current) {
            startDate.current = new Date(moment(endDate.current).subtract(1, 'days'))
            setStartDateTrigger(!startDateTrigger)
        }
    }, [endDateTrigger])

    useEffect(() => {
        if (selectBedInfo) {
            if (isFromSearch) {
                endDate.current = new Date(moment(selectBedInfo.endTime))
            } else {
                endDate.current = new Date(moment())
            }
            setEndDateTrigger(!endDateTrigger)
        }
    }, [selectBedInfo])

    useEffect(() => {
        if (typeof selectedAlarmIdx === 'number') {            
            getVitalSignDetail()
            // console.log('trendWaveData', trendWaveData);
        } else {
            setTrendWaveData()
            setTrendReviewData({})
        }
    }, [selectedAlarmIdx])

    useEffect(() => {
        if (selectedAlarmInfo && selectedAlarmInfo.startTime && selectedAlarmInfo.endTime) {
            // getTrendWave()
        } else {
            setTrendWaveData()
        }
    }, [waveStartTime, waveEndTime])

    useEffect(() => {
        const endOfEndTime = moment(selectedAlarmInfo.endTime).add(15, 'seconds')
        let newEndTime = null, newStartTime = null
        if (moment(selectedAlarmInfo.endTime).diff(moment(waveStartTime), 'seconds') > showTimeValue) {
            newEndTime = moment(waveStartTime).add(showTimeValue, 'seconds')
        } else {
            if (moment(endOfEndTime).diff(moment(waveStartTime), 'seconds') > showTimeValue) {
                newEndTime = moment(waveStartTime).add(showTimeValue, 'seconds')
            } else {
                newStartTime = moment(endOfEndTime).subtract(showTimeValue, 'seconds')
                newEndTime = moment(endOfEndTime)
                setWaveStartTime(newStartTime)
            }
        }
        setWaveEndTime(newEndTime)
    }, [showTimeValue])

    useEffect(() => {
        if (selectedAlarmInfo) {
            setActivePatientForAlarm(selectedAlarmInfo.startTime)
        }
    }, [selectedAlarmInfo])

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])

    useEffect(() => {
        // selectedAlarmIdx가 null이 아니고 activePatient가 설정된 후에만 비교
        if (isFromSearch) {
            setShowNotCurrentPatient(true)
        } else {
            setShowNotCurrentPatient(
                (!alarmLoading.current && 
                (selectedAlarmIdx !== null) && 
                (activePatient.patientId !== selectBedInfo.patientId))
            );
        }
    }, [isFromSearch, alarmLoading.current, selectedAlarmIdx, activePatient.patientId, selectBedInfo.patientId])

    return (
        <div className="relative w-full h-full bg-black" style={{  }}>
            <div ref={wrapperRef} className="flex flex-col w-full h-full">
                <div className="flex relative justify-center text-white items-center h-[32px]" style={{ color: isFromSearch ? 'white' : '', background: isFromSearch ? '#01004B' : (showNotCurrentPatient ? '#02008B' : '#2C2C2C'), borderBottomWidth: 1, borderColor: '#4E4E4E' }}>
                    <div className={`flex items-center px-2 py-1`} style={{ background: isFromSearch ? 'linear-gradient(180deg, #2D2C81 0%, #141352 100%)' : (showNotCurrentPatient ? 'linear-gradient(180deg, #2927AC 0%, #100E95 100%)' : 'linear-gradient(180deg, #DEDEDE 0%, #9F9F9F 100%)'), height: '100%' }}>
                        <div className="flex items-center justify-center mr-2 w-[178px]" style={{ color: showNotCurrentPatient ? 'white' : 'black', fontWeight: 500, fontSize: 24, lineHeight: '26.4px' }}>{isFromSearch ? '-' : checkEmptyValue(selectBedInfo.bedNumber.length <= 1 ? `0${selectBedInfo.bedNumber}` : selectBedInfo.bedNumber, `${t('dashboard.bedName')}-`)}</div>
                        <div className="truncate" style={{ color: showNotCurrentPatient ? 'white' : 'black', fontWeight: 200, fontSize: 16, lineHeight: '17.6px', minWidth: 301, maxWidth: 301 }}>
                            {
                                showNotCurrentPatient ?
                                <>
                                    { isFromSearch ? `${checkEmptyValue(selectBedInfo.patientName)} , ${checkEmptyValue(selectBedInfo.devicePatientId)}` : `${checkEmptyValue(activePatient.patientName)},${checkEmptyValue(activePatient.devicePatientId)}` }
                                </> :
                                <>
                                    { selectBedInfo.nameDisplay === '1' ? checkEmptyValue(selectBedInfo.patientName) : selectBedInfo.nameDisplay === '2' ? checkEmptyValue(selectBedInfo.devicePatientId) : selectBedInfo.nameDisplay === '3' ? `${checkEmptyValue(selectBedInfo.patientName)} , ${checkEmptyValue(selectBedInfo.devicePatientId)}`: '-'}
                                </>
                            }
                        </div>
                    </div>
                    {
                        isFromSearch &&
                        <div className="ml-3">
                            { `${moment(selectBedInfo.createdAt).format('YYYY-MM-DD HH:mm')} ~ ${selectBedInfo.status !== 'ADMITTED' ? moment(selectBedInfo.updatedAt).format('YYYY-MM-DD HH:mm') : moment(selectBedInfo.endTime).format('YYYY-MM-DD HH:mm')}` }
                        </div>
                    }
                    {
                        !isFromSearch &&
                        showNotCurrentPatient &&
                        <div className="flex items-center text-[#FFF500] ml-3">
                            <IconErrorYellow />
                            <div className="ml-1" style={{ fontWeight: 200, fontSize: 16 }}>{t('alarmReview.notCurrentPatient')}</div>
                        </div>
                    }
                    <HalfMenus 
                        selectBedInfo={selectBedInfo}
                        nowPage={'alarmReview'}
                        onTrend={onTrend}
                        onAlarmReview={null}
                        onMeasurements={onMeasurements}
                        onSetting={onSetting}
                        isFull={isAlarmFull}
                        isFromSearch={isFromSearch}
                        handleFullScreen={handleFullScreen}
                        onClose={onClose}
                    />
                </div>
                <div className="flex flex-grow text-white" style={{ height: 'calc(100% - 32px)' }}>
                    <div className="relative flex flex-col flex-1 bg-[#1F1F1F]" style={listOpen ? { minWidth: 421, maxWidth: 421 } : { width: 0, minWidth: 0, maxWidth: 0 }}>
                        {
                            listOpen &&
                            <>
                                <div className="relative h-[32px] bg-[#1F1F1F] flex justify-center items-center" style={{ minHeight: 32, boxShadow: '4px 0px 4px 0px #00000029' }}>
                                    <div className="flex items-center cursor-pointer w-full" style={{ paddingLeft: 8, paddingRight: 10 }}>
                                        <div className="flex items-center justify-center cursor-pointer mr-3" data-testid="prev-date-btn" onClick={() => { handleChangeStartDate('prev') } } style={{ opacity: isFromSearch ? (moment(endDate.current).subtract(1, 'days').isAfter(moment(selectBedInfo.startTime)) ? 1 : 0.3) : 1, background: 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)', width: 24, height: 24, borderRadius: 4, border: '1px solid #5E5E5E' }}>
                                            <IconCalendarLeft />
                                        </div>
                                        <div ref={dateModalOpenRef} className="flex items-center cursor-pointer justify-center flex-1" onClick={() => { handleDateModal() }}>
                                            <div className="ml-2 mr-1" data-testid="end-date-text">{`${moment(endDate.current).format('YYYY-MM-DD HH:mm')}`}</div>
                                            <IconCalendar />
                                        </div>
                                        <div className="flex items-center justify-center cursor-pointer ml-3" data-testid="next-date-btn" onClick={() => { handleChangeStartDate('next') } } style={{ opacity: isFromSearch ? (moment(endDate.current).isBefore(moment(selectBedInfo.endTime)) ? 1 : 0.3) : (moment().isBefore(moment(endDate.current).add(1, 'days')) ? 0.3 : 1), background: 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)', width: 24, height: 24, borderRadius: 4, border: '1px solid #5E5E5E' }}>
                                            <IconCalendarRight />
                                        </div>
                                        { 
                                            isDateModalShow &&
                                            <ReviewAreaDateModal ref={dateModalRef} calendarAlarms={calendarAlarms} isAlarmReview={true} handleClose={() => { setIsDateModalShow(false) }} handleSearch={handleSearch}/>
                                        }         
                                    </div>
                                </div>
                                <div className="h-[42px] flex items-center bg-[#1F1F1F]" style={{ padding: '0px 8px', minHeight: 42 }}>
                                    <div className="relative" ref={dropdownRef}>
                                        <div
                                            className="bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#DEDEDE] w-[150px] h-[28px] px-[8px] rounded-[4px] cursor-pointer flex items-center justify-between border border-[#5E5E5E]"
                                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                        >
                                            <div style={{ fontWeight: 300 }}>{alarmType.label}</div>
                                        </div>
                                        {isDropdownOpen && (
                                            <div data-testid="alarm-type-options" className="absolute top-[25px] bg-[#1F1F1F] w-[150px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">
                                                {alarmTypeOptions.map((type, index) => (
                                                    <div key={`alarm-type-${index}`} className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${alarmType.value === type.value ? "text-[#3182F7]" : "text-white"}`} onClick={(e) => { e.stopPropagation(); setAlarmType(type); handleChangeAlarmFilter(type, alarmTitle); setIsDropdownOpen((prev) => !prev)}}>
                                                        {type.label}
                                                        {alarmType.value === type.value && <IconCheck className="w-4 h-4 ml-2" />}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                                            {isDropdownOpen ? <IconArrowUp /> : <IconArrowDown />}
                                        </div>
                                    </div>
                                    <div className="flex-grow bg-[#343434] flex items-center gap-[10px] h-[28px] ml-1 border border-[#444444]" style={{ borderRadius: 6, padding: '7px 8px' }}>
                                        <input
                                            type="text"
                                            value={alarmTitle}
                                            onChange={(e) => {setAlarmTitle(e.target.value); handleChangeAlarmFilter(alarmType, e.target.value)}}
                                            placeholder={t('alarmReview.search')}
                                            style={{ 
                                                    outline: 'none', 
                                                    border: 'none',
                                                    boxShadow: 'none',
                                                    WebkitAppearance: 'none',
                                                    MozAppearance: 'none' 
                                                }}
                                            className={`bg-transparent w-full border-none focus:ring-0 focus:outline-none placeholder-[#DEDEDE] placeholder:opacity-30`}
                                        />
                                        <IconSearch />
                                    </div>
                                </div>
                                <div className="h-[1px] bg-[#000000] w-full mb-1" style={{ minHeight: 1 }}/>
                                <div ref={alarmListRef} className="flex-grow scrollbar bg-[#1F1F1F] relative" style={{ 
                                    paddingLeft: 8, 
                                    paddingRight: 10, 
                                    overscrollBehavior: 'none', 
                                    WebkitOverscrollBehavior: 'none',
                                    scrollbarGutter: 'stable',
                                    WebkitScrollbarGutter: 'stable',
                                    overflowAnchor: 'none',
                                    contain: 'strict',
                                    willChange: 'transform',
                                }}>
                                    {
                                        alarmLoading.current ?
                                        <div className="flex justify-center items-center w-full h-full">
                                            <img src={LoadingIcon} className="w-[32px]"/>
                                        </div> :
                                        alarmReviewList.current.length > 0 ?
                                        <div>
                                            {
                                                alarmReviewList.current.map((item, idx) => {
                                                    const changeInfo = patientChangeInfo[idx];
                                                    if (!changeInfo) return null;
                                                    
                                                    return (
                                                        <AlarmListItem
                                                            key={`alarm-${item.alarmNum}`}
                                                            item={item}
                                                            idx={idx}
                                                            selectedAlarmNum={selectedAlarmInfo.alarmNum}
                                                            currentActivePatient={changeInfo.currentActivePatient}
                                                            prevActivePatient={changeInfo.prevActivePatient}
                                                            isPatientChanged={changeInfo.isPatientChanged}
                                                            onAlarmClick={handleAlarmClick}
                                                            isFromSearch={isFromSearch}
                                                            t={t}
                                                        />
                                                    );
                                                })
                                            }
                                        </div> :
                                        <div className="flex items-center justify-center w-full h-full text-[#9F9F9F]" style={{ fontWeight: 300 }}>{t('error.noDataAvailable')}</div>
                                    }
                                </div>
                            </>
                        }
                        <div className="absolute" style={{ right: -21, top: 50, zIndex: 10 }}>
                             <div 
                                className="cursor-pointer transition-all flex items-center justify-center"
                                style={{
                                    width: '21px',
                                    height: '50px',
                                    backgroundColor: '#4E4E4E',
                                    clipPath: 'polygon(100% 0%, 0% 0%, 0% 100%, 100% 80%)',
                                    position: 'relative',
                                    top: '50%',
                                    borderRadius: 4,
                                    paddingBottom: 4,
                                }}
                                onClick={() => { setListOpen(!listOpen); setShowTimeValue(prev => prev + (listOpen ? 4 : -4)) }}
                            >
                                {
                                    listOpen ?
                                    <IconCalendarLeft /> : <IconCalendarRight />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="relative flex flex-col flex-grow" style={{ width: listOpen ? 'calc(100% - 421px)' : '100%' }}>
                        {
                            <TrendDetailView
                                isAlarmFull={isAlarmFull}
                                trendWaveData={trendWaveData} 
                                trendReviewData={trendReviewData} 
                                selectedAlarmInfo={selectedAlarmInfo}
                                waveStartTime={waveStartTime}
                                waveEndTime={waveEndTime}
                                handleChangeSpeed={(val) => val === 25 ? setShowTimeValue(listOpen ? 17 : 21) : val === 50 ? setShowTimeValue(listOpen ? 8 : 12) : setShowTimeValue(listOpen ? 34 : 38)}
                                handlePrev={() => handleWaveTime('prev')}
                                handlePrevEnd={() => handleWaveTime('prevEnd')}
                                handleNext={() => handleWaveTime('next')}
                                handleNextEnd={() => handleWaveTime('nextEnd')}
                            />
                        }
                        {
                            !alarmLoading.current &&
                            <div className='bg-[#000000] w-full h-[64px]'>
                                <Timeline selectedAlarmInfo={selectedAlarmInfo} patientHistories={patientHistories} alarmList={alarmOldList.current} startTime={startDate.current} endTime={endDate.current} handlePrevTripple={() => { handleChangeStartDate('prev') }} handleNextTripple={() => { handleChangeStartDate('next')}}/>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export function __getActivePatientAtTimeForTest(selectBedInfo, patientHistories, t, timestamp) {
    if (!patientHistories || patientHistories.length === 0) {
        return { ...selectBedInfo };
    }
    const targetTime = moment(timestamp);
    const relevantHistories = patientHistories
        .filter(h => moment(h.createdAt).isBefore(targetTime) || moment(h.createdAt).isSame(targetTime))
        .sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)));

    if (relevantHistories.length === 0) {
        const earliestHistory = [...patientHistories]
            .sort((a, b) => moment(a.createdAt).diff(moment(b.createdAt)))[0];
        if (earliestHistory && earliestHistory.action === 'UNASSIGNED') {
            return {
                patientId: earliestHistory.patientId,
                patientName: earliestHistory.patientName,
                devicePatientId: earliestHistory.devicePatientId,
                status: 'ADMITTED'
            };
        }
        return {
            patientId: null,
            patientName: t('alarmReview.notAdmitted'),
            devicePatientId: '',
            status: 'UNASSIGNED'
        };
    }
    // (라인 136 근처) 최신 액션 확인
    const latestAction = relevantHistories[0];
    if (latestAction.action === 'UNASSIGNED') {
        return {
            patientId: null,
            patientName: t('alarmReview.notAdmitted'),
            devicePatientId: '',
            status: 'UNASSIGNED'
        };
    }
    return {
        patientId: latestAction.patientId,
        patientName: latestAction.patientName,
        devicePatientId: latestAction.devicePatientId,
        status: latestAction.action
    };
}

// activeSerials 병합 로직 (326-384 근처 단순화)
export function __mergeActiveSerialsForTest(deviceHistory, startTime, endTime) {
    const sorted = [...deviceHistory].sort((a, b) => moment(a.createdAt).diff(moment(b.createdAt)));
    // 각 serial 별 활성 admission 트래킹
    const activeMap = {}; // serial -> { start }
    const spans = [];

    for (const h of sorted) {
        if (h.action === 'ADMITTED') {
            // 이미 열려 있으면 무시(겹침 방지), 없으면 새로 시작
            if (!activeMap[h.serial]) {
                activeMap[h.serial] = { serial: h.serial, start: h.createdAt };
            }
        } else if (h.action === 'UNASSIGNED') {
            const active = activeMap[h.serial];
            if (active) {
                spans.push({ serial: h.serial, start: active.start, end: h.createdAt });
                delete activeMap[h.serial];
            }
        }
    }

    // 열린 구간들은 endTime 으로 종료
    Object.values(activeMap).forEach(open => {
        spans.push({ serial: open.serial, start: open.start, end: endTime });
    });

    // 범위 교집합 계산 + 유효성 필터
    return spans
        .map(s => {
            const start = moment.max(moment(s.start), moment(startTime)).toISOString();
            const end = moment.min(moment(s.end), moment(endTime)).toISOString();
            return { serial: s.serial, start, end };
        })
        .filter(s => moment(s.start).isBefore(moment(s.end)));
}

// getPatientHistory 결과(patientHistories + latestHistory) 처리 (421-422)
export function __normalizePatientHistoryForTest(histories, latestHistory) {
    if (!histories || histories.length === 0) {
        if (latestHistory) return [latestHistory];
        return [];
    }
    // 최신 히스토리가 이미 목록에 없으면 추가
    if (latestHistory && !histories.find(h => h.createdAt === latestHistory.createdAt && h.action === latestHistory.action)) {
        return [...histories, latestHistory];
    }
    return histories;
}

// wave 이동 (433) 단순화
export function __calcWaveWindowForTest(startTime, endTime, direction, fullSpanSec = 30, viewSpanSec = 8) {
    const start = moment(startTime);
    const end = moment(endTime);
    let windowStart = start.clone();
    if (direction === 'next') {
        windowStart = start.clone().add(viewSpanSec, 'seconds');
    } else if (direction === 'prev') {
        windowStart = start.clone().subtract(viewSpanSec, 'seconds');
    } else if (direction === 'prevEnd') {
        windowStart = end.clone().subtract(viewSpanSec, 'seconds');
    } else if (direction === 'nextEnd') {
        windowStart = end.clone().subtract(viewSpanSec, 'seconds');
    }
    // 경계 보정
    if (windowStart.isBefore(start)) windowStart = start.clone();
    if (windowStart.add(viewSpanSec, 'seconds').isAfter(end)) windowStart = end.clone().subtract(viewSpanSec, 'seconds');
    return {
        windowStart: windowStart.toISOString(),
        windowEnd: windowStart.clone().add(viewSpanSec, 'seconds').toISOString()
    };
}

// 속도(showTimeValue) 변경에 따른 waveEndTime 재계산 (613)
export function __calcWaveEndTimeForTest(startTime, speedFactor) {
    // speedFactor: 1(기본), 0.5(50%), 0.25(25%)
    const baseDurationSec = 8;
    return moment(startTime).add(baseDurationSec / speedFactor, 'seconds').toISOString();
}

// selectedAlarmInfo 변경 후 activePatient 재설정 (638 근처)
export function __deriveActivePatientOnSelectForTest(selectedAlarm, histories, t) {
    if (!selectedAlarm) return null;
    return __getActivePatientAtTimeForTest(
        { patientId:null, patientName:t('alarmReview.notAdmitted'), devicePatientId:'' },
        histories,
        t,
        selectedAlarm.startTime || selectedAlarm.eventTime
    );
}

// showNotCurrentPatient (793-803)
export function __shouldShowNotCurrentPatientForTest(bedInfoPatientId, activePatient, isFromSearch) {
    if (isFromSearch) return false;
    if (!activePatient) return false;
    if (activePatient.status === 'UNASSIGNED') return false;
    return bedInfoPatientId && activePatient.patientId && bedInfoPatientId !== activePatient.patientId;
}

export default React.memo(AlarmReview);
